module.exports = __webpack_public_path__ + "img/arancini.7a4651e5.jpeg";